class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onToggle() {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    if (isOpen) {
      this.summary.setAttribute('aria-expanded', true);
      this.content.classList.add('menu-opening');
    } else {
      this.summary.setAttribute('aria-expanded', false);
      this.content.classList.remove('menu-opening');
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
    this.content.classList.remove('menu-opening');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;

    const isOpen = this.mainDetailsToggle.open;
    this.header.preventHide = isOpen;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

    super.onToggle();
  }
}

customElements.define('header-menu', HeaderMenu);